var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6858 5.94718C14.3489 10.5054 10.7554 14.0989 6.19718 15.4358C4.07735 16.0576 2.25 14.2091 2.25 12V11.75C2.25 11.1977 2.69915 10.756 3.24792 10.6937C4.01566 10.6066 4.75327 10.42 5.44758 10.1473L6.77695 11.4767C8.93911 10.442 10.692 8.68912 11.7267 6.52696L10.3973 5.19759C10.67 4.50328 10.8566 3.76567 10.9437 2.99791C11.006 2.44916 11.4477 2 12 2H12.25C14.4591 2 16.3076 3.82735 15.6858 5.94718Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.20f7c9642565076adc87e5fcbd5e983f.svg";
export { ForwardRef as ReactComponent };